import React, { ReactNode } from 'react'
import { FormattedMessage, IntlShape } from 'react-intl'

import { ClientProposalOwnerActionEnum } from '../../../../../../../lib/graphql'
import { IconName } from '../../../../../../atoms/icons/icon'

export const getEmptyStateData = ({
  ownerCurrentAction,
  intl,
  setIsOpenCreateOrUpdateQuoteProvisionModal,
  setIsOpenLoadQuotation,
}: {
  ownerCurrentAction: ClientProposalOwnerActionEnum
  intl: IntlShape
  setIsOpenCreateOrUpdateQuoteProvisionModal: (value: boolean) => void
  setIsOpenLoadQuotation: (value: boolean) => void
}): { icon: IconName; description: ReactNode } | null => {
  switch (ownerCurrentAction) {
    case ClientProposalOwnerActionEnum.CAN_RE_UPLOAD_QUOTATION:
      return {
        icon: 'paper-validated',
        description: intl.formatMessage({
          id: 'ui.emptyState.ownerCanReUploadQuotation.description',
          defaultMessage:
            'Votre devis a bien été chargé. Vous pouvez charger un autre devis en cas de modification.',
        }),
      }
    case ClientProposalOwnerActionEnum.BOOKING_DECLINED_BY_HOST:
      return {
        icon: 'paper-warning',
        description: intl.formatMessage({
          id: 'ui.emptyState.bookingDeclinedByHost.description',
          defaultMessage:
            'Impossible de charger un devis ? Contactez votre conseiller au plus vite.',
        }),
      }
    case ClientProposalOwnerActionEnum.CAN_CONFIRM_QUOTATION:
      return {
        icon: 'paper',
        description: intl.formatMessage({
          id: 'ui.emptyState.ownerCanConfirmQuotation.description',
          defaultMessage: 'Ajoutez des prestations pour créer votre devis',
        }),
      }
    case ClientProposalOwnerActionEnum.CAN_UPLOAD_QUOTATION:
      return {
        icon: 'paper',
        description: (
          <div className='font-bold'>
            <button
              className='cursor-pointer underline'
              onClick={() => setIsOpenCreateOrUpdateQuoteProvisionModal(true)}
            >
              <FormattedMessage
                id='ui.getEmptyStateData.addQuote'
                defaultMessage='Ajoutez vos prestations pour personnaliser votre devis'
              />
            </button>
            <p className='p-6 text-center'>ou</p>
            <button
              className='cursor-pointer underline'
              onClick={() => setIsOpenLoadQuotation(true)}
            >
              <FormattedMessage
                id='ui.getEmptyStateData.uploadQuote'
                defaultMessage='Chargez directement votre devis'
              />
            </button>
          </div>
        ),
      }
    default:
      return null
  }
}

export const getPlainText = (html: string | undefined) => {
  if (!html) {
    return ''
  }
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')
  return doc.body.textContent || ''
}
